module.exports = function getResource(label, vars) {
    const resources = {
        editLinkText: 'Modifier',
        giftOptionsLinkText: 'Ajouter des options de cadeaux',
        savedGiftMessage: `Message du cadeau : ${vars[0]}`,
        savedGiftWrap: `Emballage-cadeau : ${vars[0]}`,
        subTitle: 'Expédition standard – GRATUITE',
        title: 'Standard',
        autoReplenTitle: 'Livraison'
    };

    return resources[label];
};
